export class UserModel {
  uuid: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  orgUuid: string | null;
  password?: string | null;
  newPassword?: string | null;
  profileImageUrl?: string | null;
  // Add more fields as needed

  constructor({
    uuid = null,
    firstName = null,
    lastName = null,
    email = "",
    orgUuid = null,
    password = null,
    newPassword = null,
    profileImageUrl = null,
  }: {
    uuid?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    orgUuid?: string | null;
    password?: string | null;
    newPassword?: string | null;
    profileImageUrl?: string | null;
  } = {}) {
    this.uuid = uuid;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.orgUuid = orgUuid;
    this.password = password;
    this.newPassword = newPassword;
    this.profileImageUrl = profileImageUrl;
  }
}
